import { Layout } from "antd";
import styled from "styled-components";

export const StyledSider = styled(Layout.Sider)`
  .ant-layout-sider-children {
    height: 100vh;
    width: 240px;
    background-color: #f7f9fe;
  }
`;
